import { useState } from "react";
import { Modal } from "antd";
import { X as ICON_X } from 'react-feather';
import API from "api";
import { useLanguage } from "assets/languages";
import Button from "components/button";
import useAppState from "hooks/useAppState";

interface BrandRequestCreateModalProps {
  isVisible: boolean;
  letClose: (result: boolean) => void;
  token: string;
  rentalId: number;
  postingId: number;
  showModal?: any;
}

interface BrandRequestCreateButtonProps {
  posting: any;
}

const BrandRequestCreateModal = (props: BrandRequestCreateModalProps) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.component.postingCard.brandRequestCreateButton,
  };

  const [type, setType] = useState('VALIDATION_COMPLETION');

  const onSubmit = async () => {
    try {
      const response = await API.Rent.storeBrandRequest({
        brandToken: props.token,
        rentalId: props.rentalId,
        postingId: props.postingId,
        type: type,
      });
      props.letClose(true);
    } catch (e) {
      props.showModal({
        hideCloseButton: true,
        text: e.message,
      });
    }
  }

  return (
    <Modal
      wrapClassName="py-4"
      className="rounded-antd-modal"
      centered={true}
      open={props.isVisible}
      onOk={() => props.letClose(false)}
      onCancel={() => props.letClose(false)}
      footer={null}
      closable={false}
      zIndex={1090}
      width={480}
    >
      <div className="relative select-none">
        <div
          className="absolute top-[24px] right-[24px] cursor-pointer"
          onClick={() => props.letClose(false)}
        >
          <ICON_X size={24} />
        </div>
        <div className="py-[50px] flex flex-col bg-white rounded-2xl">
          <div className="flex flex-row justify-between pl-[50px] pr-[30px]">
            <span className="font-bold text-[22px] text-black whitespace-pre-wrap">
              {languageTexts.modal_request_step_1_title}
            </span>
          </div>
          <div className="mt-[30px] px-[50px] text-[15px] whitespace-pre-wrap leading-5">
            {languageTexts.modal_request_step_1_content}
          </div>
          <div className="mt-[28px] px-[50px] flex flex-row justify-between gap-[8px]">
            <Button
              text={languageTexts.cancel}
              onClick={() => {
                props.letClose(false);
              }}
              textColor="BLACK"
              borderColor={"BLACK"}
              buttonColor={"WHITE"}
            />
            <Button
              text={languageTexts.modal_request_step_1_confirm}
              onClick={() => {
                onSubmit();
              }}
              textColor="WHITE"
              borderColor={"BLACK"}
              buttonColor={"BLACK"}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

const BrandRequestCreateButton = (props: BrandRequestCreateButtonProps) => {
  const language = useLanguage();
  const languageTexts = {
    ...language.common,
    ...language.component.postingCard.brandRequestCreateButton,
  };

  const { state, actions } = useAppState(['auth', 'brand', 'preferences'])

  const showBrandRequestCreateModal = async () => {
    const response = await new Promise((resolve, reject) => {
      actions.showModal({
        content: () => {
          return (
            <BrandRequestCreateModal
              isVisible={true}
              letClose={(result) => {
                resolve(result);
                actions.closeModal();
              }}
              token={state.auth?.token}
              rentalId={props.posting?.rentalId}
              postingId={props.posting?.id}
              showModal={actions.showModal}
            />
          );
        },
      });
    });
    if (response) {
      actions.showModal({
        hideCloseButton: true,
        title: languageTexts.modal_request_step_2_title,
        text: languageTexts.modal_request_step_2_content,
      });
    }
  }

  return (
    <div
      className="mt-[14px] text-[12px] text-[#999] text-center underline cursor-pointer"
      onClick={() => showBrandRequestCreateModal()}
    >
      {languageTexts.index_1}
    </div>
  )
}

export default BrandRequestCreateButton;
